export function isH2000Device(device) {
    return device.device_type?.code === 'H2000' || device.hardware_type?.code === '515';
}
